'use strict';

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactJss = require('react-jss');

var _reactJss2 = _interopRequireDefault(_reactJss);

var _Menu = require('../Menu');

var _Menu2 = _interopRequireDefault(_Menu);

var _SideBar = require('./SideBar.style');

var _SideBar2 = _interopRequireDefault(_SideBar);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SideBar = (_dec = (0, _reactJss2["default"])(_SideBar2["default"]), _dec(_class = function (_PureComponent) {
  (0, _inherits3["default"])(SideBar, _PureComponent);

  function SideBar() {
    (0, _classCallCheck3["default"])(this, SideBar);
    return (0, _possibleConstructorReturn3["default"])(this, (SideBar.__proto__ || (0, _getPrototypeOf2["default"])(SideBar)).apply(this, arguments));
  }

  (0, _createClass3["default"])(SideBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          visibility = _props.visibility,
          id = _props.id,
          children = _props.children,
          activeItem = _props.activeItem,
          onClick = _props.onClick,
          className = _props.className;
      return _react2["default"].createElement(_Menu2["default"], {
        id: id,
        type: 'sideBar',
        className: className + ' ' + classes.sidebar,
        visibility: visibility,
        activeItem: activeItem,
        onClick: onClick
      }, _react2["default"].Children.map(children, function (child) {
        if (child.type.displayName === 'Jss(MenuItem)') {
          return _react2["default"].cloneElement(child, {
            className: classes.menuItem
          });
        } // for NavLink wrapper


        return _react2["default"].cloneElement(child, {
          className: classes.navMenuItem
        });
      }));
    }
  }]);
  return SideBar;
}(_react.PureComponent)) || _class);
SideBar.defaultProps = {
  visibility: 'visible',
  onClick: function onClick() {}
};
SideBar.propTypes = {
  classes: _propTypes2["default"].object,

  /** SideBar's visibility */
  visibility: _propTypes2["default"].oneOf(['visible', 'disabled', 'hidden']).isRequired,

  /** SideBar's id */
  id: _propTypes2["default"].string,

  /** active item */
  activeItem: _propTypes2["default"].string,

  /** sidBar's options */
  children: _propTypes2["default"].node.isRequired,

  /** onClick callback */
  onClick: _propTypes2["default"].func,

  /** additional class */
  className: _propTypes2["default"].string
};
exports["default"] = SideBar;